import _ from "lodash";
import React from "react";
import UIActions from "../actions/UIActions";
import HoverStore from "../stores/HoverStore";
import BlockUtils from "../utils/BlockUtils";
import IDUtils from "../utils/IDUtils";
import useStoreState from "./providers/useStoreState";
import BlockSelect from "./renderer/BlockSelect";
import StageRightClickMenu from "./rightclick/StageRightClickMenu";
import ElementSelector from "./stage/ElementSelector";
// Import the action registration to ensure actions are available
import "@/services/StageActionRegistration";
import GroupActions from "@/actions/GroupActions";
import { GROUP_FOCUS_MODE } from "@/constants/UIConstants";

const SelectionLayer = ({
  blocks,
  blockContainer,
  disabled,
  layout,
  layoutWidth,
  mode,
  selectedBlock,
  pageStyle,
  rightClickMenu,
  handleStageContextMenu,
  theme,
  zoom,
}) => {
  const hoverId = useStoreState(HoverStore, HoverStore.getInitialState);

  const _clickBackground = () => {
    !disabled && UIActions.clearSelectedElements();
    if (mode?.type === GROUP_FOCUS_MODE) {
      GroupActions.blurGroup();
    }
  };

  /**
   * Directs selection through it's store when called. Used for drag marquee selection.
   * @param {Object} selection
   */
  const _onSelect = (selection) => {
    !disabled &&
      UIActions.selectElement({
        ids: selection.ids,
        layout,
        blockId: selectedBlock.get("id"),
        from: "stage",
        addTo: _.get(selection, "addTo", false),
      });
  };

  /** @type {React.CSSProperties} */
  const style = {
    width: "100%",
    height: "100%",
    position: "absolute",
    pointerEvents: "auto",
    zIndex: 1,
  };

  const viewBlocks = [];
  let anyActive = false;

  /** @type {React.CSSProperties} */
  const cStyle = {
    height: "100%",
    width: layoutWidth,
    margin: "0 auto",
    position: "relative",
    paddingTop: pageStyle.paddingTop,
    paddingBottom: pageStyle.paddingBottom,
  };

  if (blocks !== null) {
    anyActive = BlockUtils.isBlockSelectedInLayout(selectedBlock, layout);

    blocks.map((block) => {
      let active = false;
      let hovered = false;
      const blockId = block.get("id");

      if (anyActive && selectedBlock.get("id") === blockId) {
        active = true;
      }

      if (hoverId === IDUtils.getID(blockId, layout)) {
        hovered = true;
      }

      if (BlockUtils.isVisibleInLayout(block, layout)) {
        const blockComponent = (
          <BlockSelect
            key={blockId}
            block={block}
            blockContainer={blockContainer}
            layout={layout}
            layoutWidth={layoutWidth}
            selectable={!anyActive}
            active={active}
            hoverId={hoverId}
            hovered={hovered}
            mode={mode}
            theme={theme}
          />
        );
        viewBlocks.push(blockComponent);
      }
      return null; // Add this line to return a value from the arrow function
    }, this);
  }

  /** @type {React.CSSProperties} */
  const backgroundStyle = {
    height: "100%",
    width: "100%",
    position: "absolute",
  };
  return (
    <ElementSelector
      id={`${layout}_stage_selection`}
      style={style}
      active={anyActive}
      // mode={mode}
      onSelect={_onSelect}
      onContextMenu={handleStageContextMenu}
      zoom={zoom}
    >
      <div id={`${layout}_stage_bg`} style={backgroundStyle} onClick={_clickBackground} />
      {/* keep hit divs mounted while disabled (crop mode): they define the
          x-scrollable extent for off-layout elements, and unmounting them
          collapses scrollWidth and snaps the scroll position */}
      <div
        id={`${layout}_stage_canvas`}
        style={disabled ? { ...cStyle, pointerEvents: "none" } : cStyle}
      >
        {viewBlocks}
      </div>
      {rightClickMenu && (
        <StageRightClickMenu menuState={rightClickMenu} onClose={UIActions.closeRightClickMenu} />
      )}
    </ElementSelector>
  );
};

export default SelectionLayer;
